"use client";

import { useEffect } from "react";
import { initializeFirebase, onForegroundMessage, isFirebaseConfigured } from "@/lib/firebase";
import { registerFCMToken } from "@/lib/browserNotifications";
import { useUser } from "@/contexts/UserContext";

const isUserInConversation = (conversationId: string): boolean => {
  if (!conversationId) return false;
  const url = window.location.href;
  return url.includes(`conversationId=${conversationId}`) || url.includes(`/conversations/${conversationId}`);
};

export function ServiceWorkerRegistration() {
  const { user } = useUser();

  useEffect(() => {
    initializeFirebase();

    if (user?.id && 'Notification' in window && Notification.permission === 'granted' && isFirebaseConfigured()) {
      registerFCMToken(user.id).then((success) => {
        if (success) {
          console.log('[ServiceWorker] FCM token registered/reactivated on startup');
        }
      }).catch((err) => {
        console.error('[ServiceWorker] FCM token registration failed:', err);
      });
    }

    onForegroundMessage((payload) => {
      console.log('[Notification:Foreground] Message received:', payload);

      const data = payload.data || {};
      const title = payload.notification?.title || data.title || 'New Notification';
      const body = payload.notification?.body || data.body || '';
      const conversationId = data.conversation_id;

      if (conversationId && isUserInConversation(conversationId)) {
        console.log('[Notification:Foreground] User is in this conversation, skipping popup');
        return;
      }

      if (Notification.permission === 'granted') {
        const link = data.link || '/';

        try {
          const notification = new Notification(title, {
            body,
            icon: '/images/achieveapex-icon.png',
            badge: '/images/achieveapex-icon.png',
            tag: conversationId || data.notification_id || 'notification',
            renotify: true,
            data: { link },
            requireInteraction: false,
          });

          notification.onclick = (event) => {
            event.preventDefault();
            window.focus();
            if (link && link !== '/') {
              window.location.href = link;
            }
            notification.close();
          };
        } catch (err) {
          console.error('[Notification:Foreground] Error creating notification:', err);
        }
      }
    });
  }, [user?.id]);

  return null;
}
